let activeRequests = 0;
const listeners = new Set();

const notifyListeners = () => {
  const isLoading = activeRequests > 0;
  listeners.forEach((listener) => listener(isLoading));
};

const startGlobalLoading = () => {
  activeRequests += 1;
  notifyListeners();
};

const stopGlobalLoading = () => {
  activeRequests = Math.max(0, activeRequests - 1);
  notifyListeners();
};

const subscribeToGlobalLoading = (listener) => {
  listeners.add(listener);
  listener(activeRequests > 0);

  return () => {
    listeners.delete(listener);
  };
};

const getIsGlobalLoading = () => activeRequests > 0;

export {
  getIsGlobalLoading,
  startGlobalLoading,
  stopGlobalLoading,
  subscribeToGlobalLoading,
};
